import { combineReducers } from 'redux';
import { PromotionCodeAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { PromotionCode } from '../../../../types/items';
import {
  clearValidationPromotionCodeWIthProduct,
  validatePromotionCodeWithProductFail,
  validatePromotionCodeWithProductRequest,
  validatePromotionCodeWithProductSuccess,
} from '../actions';

type State = Loadable<PromotionCode>;
type ReducerOf<T extends keyof State> = Reducer<State, PromotionCodeAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case validatePromotionCodeWithProductRequest.type:
    case validatePromotionCodeWithProductFail.type:
    case clearValidationPromotionCodeWIthProduct.type:
      return null;

    case validatePromotionCodeWithProductSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case validatePromotionCodeWithProductRequest.type:
      return true;

    case validatePromotionCodeWithProductSuccess.type:
    case validatePromotionCodeWithProductFail.type:
    case clearValidationPromotionCodeWIthProduct.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case validatePromotionCodeWithProductRequest.type:
    case validatePromotionCodeWithProductSuccess.type:
    case clearValidationPromotionCodeWIthProduct.type:
      return false;

    case validatePromotionCodeWithProductFail.type:
      return true;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  error,
});
